type Translator = (key: string) => string;

/**
 * Lightweight bridge so non-React modules (e.g., Axios interceptors) can reuse the
 * existing localization setup from `useApp()` without creating a parallel i18n layer.
 * The App root injects `t` via `setTranslationResolver`, and callers can then translate
 * server-provided message keys (currently used e.g. for rate-limit errors).
 */
let translator: Translator | null = null;

export const setTranslationResolver = (resolver: Translator | null) => {
  translator = resolver;
};

export const translateMessage = (message: string): string => {
  if (!message || typeof message !== "string") {
    return message;
  }
  if (!translator) {
    return message;
  }
  const translated = translator(message);
  return translated === message ? message : translated;
};
